package org.catharsis.spendtel.core.navigation

import org.catharsis.spendtel.feature.data.SpendtelUser
import org.catharsis.spendtel.feature.data.needsFinancialGoalSelection

fun resolveAppStartDestination(
    isAuthenticated: Boolean,
    user: SpendtelUser?,
): String {
    if (!isAuthenticated) {
        return defaultUnauthenticatedRoute()
    }
    return resolvePostAuthDestination(user)
}

fun resolvePostAuthDestination(user: SpendtelUser?): String {
    return if (user.needsFinancialGoalSelection()) {
        AppRoutes.FinancialGoal.name
    } else {
        AppRoutes.Home.name
    }
}
